<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Origem" prop="origem" key="origem">
              <el-input v-model="dados.origem" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Data de envio" prop="data_envio" :rules="[$requiredChange]" key="data_envio">
              <el-date-picker v-model="dados.data_envio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Itens da distribuição" titleIcon="fas fa-truck-loading">
          <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" class="u-text-right">
              <el-button type="primary" plain icon="el-icon-plus" @click="addItem">ADICIONAR ITEM</el-button>
            </el-col>
          </el-row>
          <div class="container-table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Alimento</th>
                  <th style="width: 140px;">Quantidade</th>
                  <th style="width: 120px;" class="u-text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in itens" :key="idx">
                  <td>
                    <el-select v-model="item.alimento_id" placeholder="pesquisar" filterable remote clearable :remote-method="(q) => searchAlimento(q, idx)" :loading="item.loadingAlimento">
                      <el-option v-for="a in item.alimentos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                    </el-select>
                  </td>
                  <td><el-input v-model="item.quantidade" maxlength="20"></el-input></td>
                  <td class="u-text-center">
                    <el-button v-if="edit && item.id" @click="saveItem(item)" type="info" icon="el-icon-check" size="mini" plain title="Salvar item"></el-button>
                    <el-button class="u-ml-10" @click="removeItem(item, idx)" type="danger" icon="el-icon-delete" size="mini" plain title="Remover"></el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-distribuicao" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    dados: { id: '', instituicao_id: '', origem: '', data_envio: '' },
    itens: []
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/getById/` + id, this.$store.getters.getHeaderAuth)
      this.dados = JSON.parse(JSON.stringify(res.data.distribuicao))
      this.itens = (res.data.itens || []).map(i => Object.assign({}, i, { alimentos: [], loadingAlimento: false }))
    },
    addItem () {
      this.itens.push({ id: '', distribuicao_id: '', alimento_id: '', quantidade: '', alimentos: [], loadingAlimento: false })
    },
    searchAlimento (query, idx) {
      if (!query || query.length < 2) { this.itens[idx].alimentos = []; return }
      this.itens[idx].loadingAlimento = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.itens[idx].alimentos = JSON.parse(JSON.stringify(res.data)); this.itens[idx].loadingAlimento = false })
        .catch(e => { this.itens[idx].loadingAlimento = false; this.$store.commit('throwException', e) })
    },
    async removeItem (item, idx) {
      if (this.edit && item.id) {
        await this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao-item/delete/` + item.id, this.$store.getters.getHeaderAuth)
      }
      this.itens.splice(idx, 1)
    },
    async saveItem (item) {
      const payload = Object.assign({}, item, { distribuicao_id: this.dados.id })
      if (item.id) {
        await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao-item/update/` + item.id, payload, this.$store.getters.getHeaderAuth)
      } else {
        const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao-item/store`, payload, this.$store.getters.getHeaderAuth)
        item.id = res.data.id
      }
      window.eventBus.$emit('alert', { msg: 'Item salvo.', type: 'success' })
    },
    onSubmit () {
      document.getElementById("btn-distribuicao").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        const inst = this.$store.state.config.instituicao
        if (!inst || !inst.id) {
          return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
        }
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = inst.id
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
            for (const it of this.itens) {
              if (!it.id && it.alimento_id && it.quantidade) {
                await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao-item/store`, Object.assign({}, it, { distribuicao_id: this.dados.id }), this.$store.getters.getHeaderAuth)
              }
            }
          } else {
            const payload = Object.assign({}, this.dados, { itens: this.itens.map(i => ({ alimento_id: i.alimento_id, quantidade: i.quantidade })) })
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/distribuicao/store`, payload, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitDistribuicao')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        } else if (!this.itens.length) {
          this.addItem()
        }
      }
    }
  }
}
</script>

